import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["calendarId", "clearLabel", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel", "children", "onFocusLeave", "onOpenChange", "open", "calendarPage", "onCalendarPageChange", "value", "disabledValues", "focusedValue", "onMouseDown", "renderSidebar"];
import { Fragment } from 'react';
import { Popover } from '../Popover';
import { Flex } from '../../../components/Flex/Flex';
import { View } from '../../../components/View/View';
import { CalendarFooterButtons } from './internal/CalendarFooterButtons';
import { CalendarPage } from './CalendarPage';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CalendarPagePopover = _ref => {
  let {
      calendarId,
      clearLabel,
      max,
      maxValidationMessage,
      min,
      minValidationMessage,
      onChange,
      today,
      todayLabel,
      children,
      onFocusLeave,
      onOpenChange,
      open,
      calendarPage,
      onCalendarPageChange,
      value,
      disabledValues,
      focusedValue,
      onMouseDown,
      renderSidebar
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps: _domProps,
    tokenProps
  } = filterProps(rest);
  const domProps = _domProps; // We only accept `DOMProps` via `filterProps` for this component. The `domProps` object is typed more broadly and is causing a TS error with the Popover `target` prop and the `LinkDOMProps` `target` prop.

  const calendarBody = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(CalendarPage, {
      onMouseDown: onMouseDown,
      value: value,
      id: calendarId,
      max: max,
      maxValidationMessage: maxValidationMessage,
      min: min,
      minValidationMessage: minValidationMessage,
      onChange: onChange,
      today: today,
      calendarPage: calendarPage,
      onCalendarPageChange: onCalendarPageChange,
      disabledValues: disabledValues,
      focusedValue: focusedValue
    }), /*#__PURE__*/_jsx(CalendarFooterButtons, {
      clearLabel: clearLabel,
      max: max,
      maxValidationMessage: maxValidationMessage,
      min: min,
      minValidationMessage: minValidationMessage,
      onChange: onChange,
      today: today,
      todayLabel: todayLabel
    })]
  });
  return /*#__PURE__*/_jsx(Popover, Object.assign({}, domProps, tokenProps, {
    overflow: "hidden",
    arrowSize: "none",
    content: renderSidebar ?
    /*#__PURE__*/
    // Render as a raw node to avoid PopoverBody spacing. This allows the divider between
    // the sidebar and the calendar to span the full popover height without negative margins.
    _jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(View, {
        paddingBlockStart: "500",
        paddingInlineStart: "600",
        paddingInlineEnd: "400",
        borderInlineEndWidth: "100",
        borderInlineEndStyle: "solid",
        borderInlineEndColor: "border-core-default",
        children: renderSidebar()
      }), /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "500",
        paddingInlineStart: "600",
        paddingInlineEnd: "600",
        children: calendarBody
      })]
    }) : {
      body: calendarBody
    },
    onOpenChange: onOpenChange,
    placement: "bottom right",
    onFocusLeave: onFocusLeave,
    open: open,
    children: children
  }));
};